import React from "react";
import Image from "next/image";
import Link from "next/link";
import {AccreditationSmallSection, HeaderSection} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData } from "@storyblok/react";

interface ResourcesProps {
  blok?: HeaderSection & SbBlokData;
  trustsmall?: AccreditationSmallSection & SbBlokData;
  latestBlog?: any[];
}

const Resources: React.FC<ResourcesProps> = ({ trustsmall, blok, latestBlog }) => {
  if (!blok) return null;

  // Destructure blog_post for easy handling
  // const latestBlog = blok.blog_post?.[0];

  return (
    <div className="dropdown-menu" aria-labelledby="dropdown-resources">
      <div className="container">
        <div className="row g-0">
          {/* Main Content Section */}
          <div className="col col-lg-16 col-xl-18 border-start d-flex flex-column">
            <div className="navbar-title h4 mb-0">{blok.title || "Resources"}</div>
            <div className="m-4">
              <ul className="list-unstyled row navbar-icon-links">
                {blok?.items?.map((item) => (
                  <li
                    key={item._uid}
                    className="col-24 col-lg-12 col-xl-8 d-flex flex-column"
                  >
                    <Link
                      href={item.link?.url || "#"}
                      className="d-flex text-decoration-none p-2 mx-n2"
                    >
                      {item.using_icon && (
                        <i
                          className={`fas fa-${item.icon_class} fa-fw me-2 lh-base`}
                        ></i>
                      )}
                      <div>
                        <span className="h4 d-block mb-1">{item.label}</span>
                        <span className="d-block mb-0 text-muted small">
                          {item.icon_description}
                        </span>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-24 small fw-bolder text-center text-muted text-uppercase h-ruled mb-0 mt-auto d-none d-lg-flex">
              Trusted Cyber & Compliance Services
            </div>

            <div className="p-4 d-none d-lg-block">
              <div className="row align-items-center justify-content-center g-3 g-xl-2 g-xxl-3">
                {trustsmall?.accreditations?.map((accreditation) => (
                  <div className="col-auto" key={accreditation._uid}>
                    <Image
                      src={accreditation?.image?.filename || "" }
                      alt={accreditation?.alt_image ||  ""}
                      title={accreditation?.alt_image || ""}
                      width={accreditation?.width ? Number(accreditation?.width) : 41}
                      height={accreditation?.height ? Number(accreditation?.height) : 41}
                      className="img-fluid"
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      loading="lazy"
                      quality={75}
                    />
                  </div>
                ))}

              </div>
            </div>
          </div>

          {/* Latest Blog Section */}

          {latestBlog && latestBlog.length > 0 && (
            <div className="d-none d-lg-block col col-lg-8 col-xl-6 border-start border-end bg-light">
              <div className="navbar-header-img position-relative">
                <Image
                  src={latestBlog[0].content?.hero_blog_post?.[0]?.image?.filename || latestBlog[0].content?.blog_details?.[0]?.thumb?.filename || ""}
                  alt={latestBlog[0].content?.hero_blog_post?.[0]?.title || ""}
                  className="img-fluid img-cover"
                  width={800}
                  height={600}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
                <span className="blog-preview-tag latest-blog">Latest Blog</span>
              </div>
              <div className="m-4">
                <h3 className="mb-3">
                  {latestBlog[0].content?.hero_blog_post?.[0]?.title || latestBlog[0].content?.blog_details?.[0]?.title || latestBlog[0].name || ""}
                </h3>
                {latestBlog[0].content?.blog_author && latestBlog[0].content?.blog_author.length > 0 && (
                  <p className="blog-preview-note mb-3">
                    <Image
                      src={latestBlog[0].content.blog_author[0].content?.image?.filename || ""}
                      alt="Profile picture"
                      className="rounded-circle me-1 js-lazy-load"
                      width={30}
                      height={30}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      loading="lazy"
                      quality={75}
                    />
                    {latestBlog[0].content.blog_author[0].content?.name || ""}
                  </p>
                )}
                <p className="mb-4">
                  {latestBlog[0].content?.hero_blog_post?.[0]?.description ||
                    latestBlog[0].content?.blog_details?.[0]?.description?.content?.[0]?.content?.[0]?.text || ""}
                </p>
                <p className="blog-preview-link mb-0">
                  {latestBlog?.[0] &&
                    <Link
                      href={`/blog/${latestBlog[0].slug}`}
                      className="d-block btn btn-primary rounded-pill"
                      aria-label={`Read more about ${latestBlog[0].title}`}
                      title={`Read more about ${latestBlog[0].title}`}
                    >
                      Read More <span className="visually-hidden">about {latestBlog[0].title}</span>
                    </Link>
                  }
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Resources;